import { create } from '@storybook/theming/create';

export default create({
  
  brandTitle: 'Orbit Design System',
  brandUrl: 'https://dev.portal.orbitspot.com/',

  // UI
  appContentBg: '#FFF',
  
    
  // Typography
  fontBase: '"Mulish", sans-serif',
  fontCode: 'monospace',

});
